export default {
  C202a_Index: {
    generalTab: 'Thông tin chung',
    detailOptionTab: 'Tùy chọn hiển thị',
  },
  generalTab: {
    bankTransfer: 'Chuyển khoản',
    cashAtTreasury: 'Tiền mặt tại KB',
    cashAtBank: 'Tiền mặt tại NH',
    refNo: 'Số giấy rút',
    project: 'CTMT, DA',
    projectToolTip: 'Chương trình mục tiêu, dự án',
    commitmentAndStructureContract: 'Số CKC, HĐK',
    commitmentAndStructureContractToolTip: 'Số cam kết chi, Hợp đồng khung',
    commitmentAndActionContract: 'Số CKC, HĐTH',
    commitmentAndActionContractToolTip: 'Số cam kết chi, Hợp đồng thực hiện',
    showToContentCol: 'Hiển thị thông tin kèm theo lên cột nội dung',
    showReceiptOrg: 'Hiển thị đơn vị nhận tiền',
    orgName: 'Đơn vị nhận tiền',
    payee: 'Người nhận tiền',
    address: 'Địa chỉ',
    openAt: 'Mở tại',
    accountingObjectBankAccount: 'Mã ngân hàng, KB',
    accountingObjectBankName: 'Tại KBNN (NH)',
    bankAccount: 'Tài khoản',
    identificationNumber: 'CMND',
    issueDate: 'Cấp ngày',
    issueBy: 'Nơi cấp',
    CompanyName: 'Đơn vị rút dự toán',
    CompanyCode: 'Mã quan hệ NS',
  },
  detailOptionTab: {
    paymentDetails: 'Nội dung thanh toán là',
    notRepeatDuplicate: 'Không lặp lại MLNS ( nếu trùng )',
    emptyColumns: 'Để trống cột Mã ngành KT, Mã nguồn (trường hợp Tạm ứng)',
    showAdditionalRow: 'Hiển thị thêm dòng',
    toContentColumn: 'lên cột nội dung',
    repeatTitleSignature: 'Lặp lại tiêu đề và chữ ký ở các trang',
    rowInOnePage: 'Số dòng 1 trang',
    emptyRowInLastPage: 'Số dòng trống ở trang cuối',
    pageAfterLowerAquaterPage: 'Các trang sau hạ thấp 1/4 trang',
    previewDescription: 'Xem trước',
  },
};
